import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { countriesInterface, packagesInterface, Payment_method_interface } from 'src/core/interfaces/auth.interface';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'app-create-package',
  templateUrl: './create-package.component.html',
  styleUrls: ['./create-package.component.css']
})
export class CreatePackageComponent implements OnInit , OnDestroy {

  
  form: FormGroup;
  countries: countriesInterface[] = [];
  packages: packagesInterface[] = [];
  payment_methods: Payment_method_interface[] = [];
  is_cash : boolean = false;
  uploaded_file : File;

  
  
  constructor(
    private r : Router,
    private fb: FormBuilder,
    private auth_s: AuthService,
    private cookie_s: CookieService
  ) { }

  ngOnInit(): void 
  {

    // redirect to sign-in when not signed-in
    this.check_if_user_signed_in();


    // get available packages
    this.get_all_packages();
    

    // get available payment methods
    this.get_payment_methods();


    
    // create form
    this.create_form();


  }


  ngOnDestroy(): void 
  {
    this.form.reset();
  }



  
  
  create_form()
  {
    
    this.form = this.fb.group({
      payment_type_id : [0 , Validators.required],
      packge_id : [0 , Validators.required]
    });
    
    
  }
  
  
  get_all_packages()
  {

    this.auth_s.get_all_packages().subscribe(
      (data : any)=>{
        this.packages = data.data;
      },
      (err)=>{
        console.error(err);
      }
    );

  }


  get_payment_methods()
  {

    this.auth_s.get_payment_methods().subscribe(
      (data : any)=>{
        this.payment_methods = data.data;
      },
      (err)=>{
        console.error(err);
      }
    );

  }
  




  payment_method_changed(payment_select : HTMLSelectElement)
  {

    if (  Number(payment_select.value) == 2 )
    {
      this.is_cash = true;
    }
    else
    {
      this.is_cash = false;
    }

  }



  check_if_user_signed_in()
  {

    let user = this.cookie_s.get('token');

    if ( user )
    {
      // do nothing
    }
    else
    {
      
      // redirect to sign-in page
      this.r.navigate([ 'auth', 'sign-in']);

    }


  }


  
  file_upload(event : any)
  {

    this.uploaded_file = event.target.files[0];


  }




  
  create_package()
  {

    if ( this.form.valid )
    {

      
      // convert values to numbers
      this.form.value.packge_id = Number(this.form.value.packge_id);
      this.form.value.payment_type_id = Number(this.form.value.payment_type_id);


      // in case of : visa/credit card (paymob)
      if ( this.form.value.payment_type_id == 1 )
      {


        // add package status attribute and assign it 'pending' to package
        this.form.value.package_status_id = 3;

        // create form data
        let form_data = new FormData();

        form_data.append('data' , JSON.stringify(this.form.value));

        this.auth_s.create_package(form_data).subscribe(
          (data : any)=>{
            
            // reset form
            this.form.reset();

            // redirect to sign-in
            this.r.navigate(['auth' , 'account' , 'my-packages']);
            
          },
          (err)=>{

            alert('Failed to create package : ' + err.message);
          
          }
        );

      }
      // in case of : cash (bank transfer)
      else if ( this.form.value.payment_type_id == 2 )
      {


        // add package status attribute and assign it 'pending' to package
        this.form.value.package_status_id = 3;

        // create form data
        let form_data = new FormData();

        form_data.append('data' , JSON.stringify(this.form.value)); 
        form_data.append('photo' , this.uploaded_file );


        this.auth_s.create_package(form_data).subscribe(
          (data : any)=>{
            
            // reset form
            this.form.reset();

            // redirect to sign-in
            this.r.navigate(['auth' , 'account' , 'my-packages']);
            
          },
          (err)=>{

            alert('Failed to buy package : ' + err.message);
          
          }
        );
        

      }





    }
    else
    {
      alert("Something wrong happened! please try again later.");
    }

  }





}
